import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ palette, spacing, typography, breakpoints }) => {
  const cardWidth = spacing(35.25)
  const cardGap = spacing(2)

  return {
    carouselContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: spacing(3),
      [breakpoints.down('md')]: {
        gap: spacing(1),
        justifyContent: 'center'
      }
    },
    carouselContent: {
      flex: 1,
      overflow: 'hidden',
      position: 'relative',
      padding: 0,
      margin: 0
    },
    carouselSlides: {
      display: 'flex',
      transition: 'transform 0.3s ease-in-out',
      willChange: 'transform',
      padding: 0,
      margin: 0
    },
    cardsContainer: {
      display: 'flex',
      gap: cardGap,
      width: 'max-content',
      justifyContent: 'flex-start',
      flexWrap: 'nowrap'
    },
    carouselButton: {
      backgroundColor: palette.grey[100],
      '&:hover': {
        backgroundColor: palette.grey[200]
      },
      '&:disabled': {
        opacity: 0.3
      },
      [breakpoints.down('md')]: {
        minWidth: 40,
        minHeight: 40,
        padding: spacing(1)
      }
    },
    authorCard: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      padding: spacing(1.5),
      borderRadius: spacing(1),
      backgroundColor: palette.background.paper,
      boxShadow: 'none',
      border: `1px solid ${palette.grey[200]}`,
      width: cardWidth,
      height: 'auto',
      margin: 0,
      flex: `0 0 ${cardWidth}`,
      [breakpoints.down('lg')]: {
        width: spacing(32.5), // 260px
        flex: `0 0 ${spacing(32.5)}`
      },
      [breakpoints.down('md')]: {
        width: spacing(30), // 240px
        flex: `0 0 ${spacing(30)}`
      },
      '&:hover': {
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
        transform: 'translateY(-2px)',
        transition: 'all 0.3s ease'
      }
    },
    authorAvatar: {
      width: spacing(12),
      height: spacing(12),
      marginBottom: spacing(1),
      border: `2px solid ${palette.grey[100]}`,
      objectFit: 'cover'
    },
    authorName: {
      ...typography.h6,
      fontWeight: typography.fontWeightBold,
      marginBottom: spacing(0.25),
      color: palette.text.primary
    },
    authorTitle: {
      ...typography.caption,
      fontWeight: typography.fontWeightBold,
      textTransform: 'capitalize',
      letterSpacing: '0.5px',
      marginBottom: spacing(0.5),
      color: palette.text.secondary
    },
    authorDescription: {
      ...typography.body2,
      lineHeight: 1.4,
      color: palette.text.secondary,
      marginBottom: spacing(1)
    },
    seeAuthorButton: {
      ...typography.caption,
      padding: spacing(0.5, 1.5),
      marginTop: 12,
      textTransform: 'none',
      borderColor: palette.grey[300],
      color: palette.text.primary
    }
  }
})
